export { default, modalActions, modalSlice } from "./modalSlice";

export enum MODAL {
  ADD_NOTES = "ADD_NOTES",
  PAY_INVOICE = "PAY_INVOICE",
  DELETE_USER = "DELETE_USER",
  ADD_PAYMENT = "ADD_PAYMENT",
  HANDLE_STATUS = "HANDLE_STATUS",
  CHILDREN_SEATS = "CHILDREN_SEATS",
  ASSIGN_BOOKING = "ASSIGN_BOOKING",
  DISABLE_DRIVER = "DISABLE_DRIVER",
  CANCEL_BOOKING = "CANCEL_BOOKING",
  REQUEST_CANCELLATION = "REQUEST_CANCELLATION",
  MARKET_TRANSFER = "MARKET_TRANSFER",
  UPLOAD_DOCUMENT = "UPLOAD_DOCUMENT",
  UPLOAD_CONTACTS = "UPLOAD_CONTACTS",
  UPLOAD_DOC = "UPLOAD_DOC",
  CONFIRMATION_FORM = "CONFIRMATION_FORM",
  CLOSE_TICKET_FORM = "CLOSE_TICKET_FORM",
  UPDATE_PAYMENT_LINK_FORM = "UPDATE_PAYMENT_LINK_FORM",
  EDIT_SPECIAL_PRICE = "EDIT_SPECIAL_PRICE",
  CONFIRMATION_MODAL = "CONFIRMATION_MODAL",
  EXPORT_TABLE_OPTIONS = "EXPORT_TABLE_OPTIONS",
  UPDATE_BOOKING_STATUS = "UPDATE_BOOKING_STATUS",
  UPDATE_BOOKING_BILLING_ADDRESS = "UPDATE_BOOKING_BILLING_ADDRESS",
  UPDATE_PAYROLL = "UPDATE_PAYROLL",
  UPDATE_DYNAMICS = "UPDATE_DYNAMICS",
  UPDATE_PAYMENT_STATUS = "UPDATE_PAYMENT_STATUS",
  ADD_ATTACHMENT = "ADD_ATTACHMENT",
  EDIT_ADDRESS = "EDIT_ADDRESS",
  EDIT_ADDRESS1 = "EDIT_ADDRESS1",
  REFUND = "REFUND",
  CONFIRM_REFUND = "CONFIRM_REFUND",
  SEARCH_HISTORY_STATS = "SEARCH_HISTORY_STATS",
  ASSIGN_PRICE = "ASSIGN_PRICE",
  UPDATE_CROSS_COUNTRY_PRICE = "UPDATE_CROSS_COUNTRY_PRICE",
  UPDATE_AGGREGATOR_MARKUP = "UPDATE_AGGREGATOR_MARKUP",
  UPDATE_TANFEETHI = "UPDATE_TANFEETHI",
  UPDATE_AL_MASAR = "UPDATE_AL_MASAR",
  BOOKING_DETAILS = "BOOKING_DETAILS",
  Add_SHIFT = "Add_SHIFT",
  DYNAMIC_CAR_MOVEMENT = "DYNAMIC_CAR_MOVEMENT",
  FINISH_CAR_MOVEMENT = "FINISH_CAR_MOVEMENT",
  INDIVIDUAL_DISCOUNT = "INDIVIDUAL_DISCOUNT",
  SET_SMART_SCRIPT = "SET_SMART_SCRIPT",
  DYNAMIC_SELECTIONS = "DYNAMIC_SELECTIONS",
  VEHICLE_SUB_STATUS = "VEHICLE_SUB_STATUS",
  DRIVER_SUB_STATUS = "DRIVER_SUB_STATUS",
  ADD_DELIVERY_CAR_CATEGORY = "ADD_DELIVERY_CAR_CATEGORY",
  ADD_DELIVERY_CAR_EXTRA = "ADD_DELIVERY_CAR_EXTRA",
  UPDATE_DELIVERY_BOOKING = "UPDATE_DELIVERY_BOOKING",
  UPDATE_STATUS="UPDATE_STATUS",
  CANCLE_STATUS="CANCLE_STATUS",
  IMAGE_GALLERY="IMAGE_GALLERY",
  PROTECTION_DETAILS="PROTECTION_DETAILS",
  MARK_EXTRA_CHARGE_PAID="MARK_EXTRA_CHARGE_PAID",
  ASSIGN_DRIVER="ASSIGN_DRIVER",
  ADD_COMPANY_INVOICE = "ADD_COMPANY_INVOICE",

  UPDATE_PAYMENT_FOR_BOOKING = "UPDATE_PAYMENT_FOR_BOOKING",
  SEND_CONTRACT = "SEND_CONTRACT",
  REFUND_PAYMENT_LINK = "REFUND_PAYMENT_LINK",
  HANDOVER_CATEGORY = "HANDOVER_CATEGORY",
  HANDOVER_SUBCATEGORY = "HANDOVER_SUBCATEGORY",
  EDIT_KIOSK_DEVICE = "EDIT_KIOSK_DEVICE",
  RETURN_ASSET = "RETURN_ASSET",
  RETURN_ECAR = "RETURN_ECAR",
  GENERATE_DRIVER_REPORT = "GENERATE_DRIVER_REPORT",
  DRIVER_ATTENDANCE = "DRIVER_ATTENDANCE",
  DRIVER_POSITION = "DRIVER_POSITION",
  CAMPAIGN_REVENUE = "CAMPAIGN_REVENUE",
  UPDATE_MC_BOOKING = "UPDATE_MC_BOOKING",
  AGGREGATOR_DETAILS = "AGGREGATOR_DETAILS",
  HOURLY_DESTINATION = "HOURLY_DESTINATION",
}

export type ModalType = "" | keyof typeof MODAL;

export interface OpenModalState {
  data: any;
  width: any;
  type: ModalType;
  loading?: boolean;
  closeBackdropClick?: boolean;
}

export type ModalState = OpenModalState & {
  open: boolean;
};
